import { render, staticRenderFns } from "./OBSProgramWidget.vue?vue&type=template&id=f441b21c&scoped=true"
import script from "./OBSProgramWidget.vue?vue&type=script&lang=js"
export * from "./OBSProgramWidget.vue?vue&type=script&lang=js"
import style0 from "./OBSProgramWidget.vue?vue&type=style&index=0&id=f441b21c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f441b21c",
  null
  
)

export default component.exports